import React from "react";
import styled from "styled-components";

import SearchIcon from "../../../icons/search";
import Link from "../../link/link";
import { Script } from "gatsby";

const Button = styled(Link)({
  appearance: "none",
  backgroundColor: "unset",
  border: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const SearchButton = () => {
  const onClick = () => {
    const el = document.getElementById("searchWidgetTrigger");
    el.click();
  };

  return (
    <div>
      <Script src="https://cloud.google.com/ai/gen-app-builder/client?hl=en_US" />
      <gen-search-widget
        configId="0644752c-52a2-49ad-878e-69176801aa37"
        triggerId="searchWidgetTrigger"
      ></gen-search-widget>
      <input style={{ display: "none" }} id="searchWidgetTrigger" />
      <button onClick={onClick}>
        <SearchIcon height={20} width={20} />
      </button>
    </div>
  );
};

export default SearchButton;
